import { useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { BugIcon, XIcon, SpinnerGapIcon } from "@phosphor-icons/react";
import { reportIssue } from "../lib/api";
import { getClientId } from "../lib/clientId";

export const ReportIssueWidget = () => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (!msg.trim()) return;
    setSending(true);
    try {
      await reportIssue({ message: msg.trim(), clientId: getClientId(), path: window.location.pathname });
      toast.success("Thanks — we're on it.");
      setMsg("");
      setOpen(false);
    } catch {
      toast.error("Couldn't send — try again.");
    }
    setSending(false);
  };

  return (
    <>
      <button
        data-testid="report-issue-fab"
        onClick={() => setOpen(true)}
        title="Report an issue"
        className="fixed bottom-4 right-4 z-40 flex items-center gap-2 px-3.5 py-2.5 bg-card border border-white/15 text-muted-foreground hover:text-neon hover:border-neon/40 transition-colors shadow-lg text-xs font-semibold"
      >
        <BugIcon size={16} /> <span className="hidden sm:inline">Report issue</span>
      </button>

      {open && createPortal(
        <div data-testid="report-issue-modal" className="fixed inset-0 z-[110] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={() => setOpen(false)}>
          <div className="bg-card border border-white/15 max-w-md w-full p-5 space-y-4" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <h3 className="font-heading font-bold text-lg flex items-center gap-2"><BugIcon size={18} className="text-neon" /> Report an issue</h3>
              <button data-testid="report-issue-close" onClick={() => setOpen(false)} className="p-1.5 text-muted-foreground hover:text-white"><XIcon size={20} /></button>
            </div>
            <p className="text-xs text-muted-foreground">Spotted a bug, wrong number, or something broken? Tell us — it goes straight to the team.</p>
            <textarea
              data-testid="report-issue-input"
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              rows={4}
              maxLength={1000}
              autoFocus
              placeholder="What went wrong? Include what you expected to see."
              className="w-full bg-black/40 border border-white/15 focus:border-neon/50 outline-none p-3 text-sm resize-none transition-colors"
            />
            <button
              data-testid="report-issue-submit"
              onClick={submit}
              disabled={sending || !msg.trim()}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-neon text-black font-semibold text-sm hover:bg-neon/90 transition-colors disabled:opacity-50"
            >
              {sending ? <SpinnerGapIcon size={16} className="animate-spin" /> : null} Send report
            </button>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};
